import { SkeletonProps } from '@mui/material';
import { StyledSkeleton } from './AppSkeletonStyles';

export const AppSkeleton = (props: SkeletonProps) => <StyledSkeleton {...props} />;
